module.exports = ".list-root-container {\r\n    min-width: 150px;\r\n    max-width: 500px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .list-root-container-full-width {\r\n    width: 100%;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/list-root-containers/list-root-containers.component.css
// module id = ./src/app/list-root-containers/list-root-containers.component.css
// module chunks = main